import React, { useCallback, useEffect } from 'react';
import { Button } from 'antd';

import { APP_CONFIG } from '../../../config';
import { ReactComponent as Undraw } from '../../../assets/img/undraw_unexpected_friends_tg6k.svg';
import ChitkaraLogo from '../../../assets/img/chitkara_wide.png';
import './general.scoped.css';

export const ReinstallApp = () => {
	useEffect(() => {
		if ('api' in window) {
			setTimeout(() => {
				if ('api' in window) (window.api as any)._sendToMain('_change-closeable-state', true);
			}, 1000);
		}
	}, []);

	const handleExit = useCallback(async () => {
		if ('api' in window) {
			await (window.api as any)._sendToMain('_change-closeable-state', true);
			window.close();
		}
	}, []);

	return (
		<div className="general-error">
			<div
				style={{
					width: '100%',
					fontSize: '40rem',
					fontWeight: 900,
					color: '#de683411',
					textAlign: 'center',
					zIndex: -1,
					position: 'fixed',
				}}
			>
				<span>409</span>
			</div>
			<div className="header">
				<div className="cq-logo">
					{!APP_CONFIG.isChitkara
						&& (
							<a href={`${APP_CONFIG.QuizServerURL}/logout`}>
								<span>code</span>
								<span>quotient</span>
							</a>
						)}
					{APP_CONFIG.isChitkara
						&& (
							<a href={`${APP_CONFIG.QuizServerURL}/logout`}>
								<img src={ChitkaraLogo} alt="Logo" height={50} />
							</a>
						)}
				</div>
			</div>
			<div className="general-error-container">
				<div className="left-pane">
					<div className="circle-artwork">
						<div className="circle-1" />
						<div className="circle-2" />
						<div className="circle-3" />
					</div>
					<div className="text-container">
						<h1>Tampering Detected!</h1>
						<p>
							App integrity check failed.
							Please try again after reinstalling the application.
						</p>
						<Button style={{ fontSize: '18px' }} type="link" onClick={() => handleExit()}>Exit</Button>
					</div>
				</div>
				<div className="right-pane">
					<Undraw style={{ maxWidth: '500px', aspectRatio: '1' }} />
				</div>
			</div>
		</div>
	);
};
